export default __webpack_public_path__ + "static/media/edit_this_cookie_export.92f6865c.jpg";